export const METRIC_ACTION = {
    QUIZ_VISIT: 'qv',
    QUIZ_CREATE: 'qc',

    SEARCH_EXECUTE: 'se',
    LIMIT_BREACH: 'lb',
} as const;
